// src/components/dashboard/TechnicianActivityTable.jsx

import React from 'react';
import { DashboardSection, PAGE } from '../ui';
import { Icons } from './Icons';

export default function TechnicianActivityTable({ activities }) {
  return (
    <DashboardSection
      title="Technician Activity Log"
      subtitle="Recent scans, updates & maintenance actions"
      bodyPadding={0}
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 0 }}
    >
      <div style={{ flex: 1, minHeight: 0, overflow: 'visible' }}>
        {activities.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center', color: PAGE.colors.muted }}>
            No recent activity
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${PAGE.colors.line}` }}>
                <th style={PAGE.type.tableHead}>Technician</th>
                <th style={PAGE.type.tableHead}>Date</th>
                <th style={PAGE.type.tableHead}>Time</th>
              </tr>
            </thead>
            <tbody>
              {activities.map((row, i) => (
                <tr
                  key={i}
                  style={{
                    borderBottom:
                      i !== activities.length - 1 ? `1px solid ${PAGE.colors.line}` : 'none',
                  }}
                >
                  <td
                    style={{
                      ...PAGE.type.tableCell,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <Icons.user /> {row.userName}
                  </td>
                  <td style={{ ...PAGE.type.tableCell, color: PAGE.colors.muted }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Icons.calendar /> {row.date || '—'}
                    </div>
                  </td>
                  <td style={{ ...PAGE.type.tableCell, color: PAGE.colors.muted }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Icons.clock /> {row.time || '—'}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardSection>
  );
}
